
import { defineComponent } from 'vue'
import { smoothScroll } from '@white-label-helper/scroll'
import { dataTestIdScrollTopButton } from './settings'

export default defineComponent({
  name: 'ScrollTopButton',

  components: {
    IconS3: () => import('@white-label-icon/icons-s3'),
  },

  methods: {
    dataTestIdScrollTopButton() {
      return dataTestIdScrollTopButton
    },
    scrollToTop () {
      smoothScroll('body')
    }
  }
})
